import ItemContainer from "@client/content/Containers/Item/container";
import { RedirectLinkEntity } from "@client/content/controls/Link/Redirect/container";
import { getContainerProps, getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import classnames from "classnames";
import * as React from "react";

export type SocialIconItemComponentProps = RootContainerProps & {
  socialIcon: string;
  style: React.CSSProperties;
};

export default (props: SocialIconItemComponentProps) => (
  <ItemContainer {...getContainerProps(props)} className={classnames("icon_wrap", props.socialIcon)} tag="li">
    <RedirectLinkEntity {...getEntityRef(props)} className={classnames(props.socialIcon, "icon")} style={props.style}>
      <i className={`fab fa-${props.socialIcon}`} />
    </RedirectLinkEntity>
  </ItemContainer>
);
